import React from 'react';
import Header from './header'
import Days from './days'
import _ from 'lodash'
import { axios } from '~/axios'
import { format, differenceInCalendarDays } from "date-fns";
import GridItem from '~/modules/Events/GridItem'

import './styles.scss'

const DAYS_OF_WEEK = ['Su', 'M', 'Tu', 'We', 'Th', 'Fr', 'Sa']
const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
 
class Calendar extends React.Component {
  constructor(props) {
    super(props)

    var currentDate = new Date()

    this.state = {
      year: currentDate.getFullYear(),
      month: currentDate.getMonth(),
      date: currentDate.getDate(),
      selectedYear: currentDate.getFullYear(),
      selectedMonth: currentDate.getMonth(),
      selectedDate: currentDate.getDate(),
      startDay: 1,
      eventPopup: false,
      eventPopupStyles: {},
      currentEvent: {},
      overflow: '',
      events: {},
      mobileOverlayEvents: [],
      type: props.type
    };
   
    this.toggleDisplayEvents = this.toggleDisplayEvents.bind(this)
    this.displayEventsMobile = this.displayEventsMobile.bind(this)
    this.next = this.next.bind(this)
    this.prev = this.prev.bind(this)
    this.getEvents = this.getEvents.bind(this)
    this.hide = this.hide.bind(this)
    this.resizeOverlayContainer = this.resizeOverlayContainer.bind(this)
  }

  componentDidMount(){
    this.getEvents(this.state.year, this.state.month)
    this.hide()
    window.addEventListener('resize', this.hide)
    window.addEventListener('resize', _.debounce(this.resizeOverlayContainer, 200))
  }

  resizeOverlayContainer() {
    setTimeout( () => {
      var overlayContainer = this.calendar.querySelector('.overlay-events-container')
      if (!overlayContainer)
        return 
  
      const rect = this.calendar.getBoundingClientRect()
      const styles = {
        position: 'absolute',
        top: this.calendar.offsetTop,
        height: rect.height,
        width: rect.width
      }
      this.setState({
        mobileStyles: styles
      })
    }, 500)
  }

  getEvents(year, month) {
    if (this.state.events[`${month}/${year}`]) 
      return

    this.setState({
      loading: true
    })

    const fromDate = Math.floor(new Date(year, month, 1).getTime() / 1000)
    const toDate = Math.floor(new Date(year, month + 1, 1).getTime() / 1000)
    axios.get(`/content/event/schedule`, {
      params: {
        from: fromDate,
        to: toDate
      }
    }).then(response => {
      this.setState({
        events: { ...this.state.events, [`${month}/${year}`]: this.filterEvents(response.data, fromDate * 1000, toDate * 1000) },
        loading: false
      })
      // we are calling next method here to get the 6 events, we call it untill we get the 6 events and future months if we get no events for the 3 consecutive months we are stopping the next method 
    }).catch(err => {
      console.log(err)
      //throw err.response.data
    })
  }

  next() {
    this.setState({
      eventPopup: false
    })
    if (this.state.month === 11) {
      this.setState({
        month: 0,
        year: this.state.year + 1
      })
      this.getEvents(this.state.year + 1, 0)
    } else {
      this.getEvents(this.state.year, this.state.month + 1)
      this.setState({
        month: this.state.month + 1
      })
    }
  }

  prev() {
    this.setState({
      eventPopup: false
    })
    if (this.state.month === 0) {
      this.setState({
        month: 11,
        year: this.state.year - 1
      })
      this.getEvents(this.state.year - 1, 11)
    } else {
      this.setState({
        month: this.state.month - 1
      })
      this.getEvents(this.state.year, this.state.month - 1)
    }
  }

  filterEvents(events, fromDate, toDate) {
    let filteredEvents = []
    events.forEach(event => {
      if (event.gist.eventSchedule.length > 0) {
        event.gist.eventSchedule.forEach(schedule => {
          event.scheduleDate = schedule.eventDate * 1000 //+ new Date(schedule.eventDate * 1000).getTimezoneOffset() * 60 * 1000
          event.eventTime = schedule.eventTime * 1000 //+ new Date(schedule.eventTime * 1000).getTimezoneOffset() * 60 * 1000
          if (event.scheduleDate >= fromDate && event.scheduleDate <= toDate){
            let scheduleDate = new Date(event.scheduleDate)
            event.date = scheduleDate.getDate()
            event.year = scheduleDate.getFullYear()
            event.month = scheduleDate.getMonth()
            event.schedule = schedule
            filteredEvents.push(event)
          }
        })
      }
    })
    return filteredEvents
  }

  hide() {
    this.setState({
      tabletView: window.innerWidth < 1025
    })
  }
  
  componentWillReceiveProps(nextProps){
    this.setState({
     eventPopup: nextProps.eventPopup,
     type: nextProps.type
    })
  }


  toggleDisplayEvents(e) {
    const target = e.currentTarget
    const event = JSON.parse(target.dataset.event)
    const parent = e.currentTarget.parentElement
    const coordinates = parent.getBoundingClientRect();
    const cw = window.document.body.clientWidth;
    const rightOverflow = (cw < coordinates.right + coordinates.width + 340)
    const leftOverflow = (coordinates.left < 340)
    var style = {}, overflow = ''
    if (rightOverflow && !leftOverflow) {
      style = {
        left: coordinates.left - 340 - 10,
        top: parent.offsetTop - ((235 - coordinates.height)/2)
      }
      overflow = 'right'
    } else {
      if (rightOverflow && leftOverflow) {
        style = {
          left: parent.offsetLeft - 340 / 2 + coordinates.width / 2,
          top: parent.offsetTop + (coordinates.height) + 10
        }
        overflow = "top"
      } else {
        style = {
          left: parent.offsetLeft + parent.offsetWidth + 10,
          top: parent.offsetTop - ((235 - coordinates.height) / 2)
        }
        overflow = "left"
      }
    }
    const isEqual = _.isEqual(event, this.state.currentEvent)
    if (isEqual) {
      this.setState({
        eventPopup: !(this.state.eventPopup),
        eventPopupStyles: style,
        currentEvent: event,
        overflow: overflow
      })
    } else {
      this.setState({
        eventPopup: true,
        eventPopupStyles: style,
        currentEvent: event,
        overflow: overflow
      })
    }
  }

  displayEventsMobile(e){
    const target = e.currentTarget
    const events = JSON.parse(target.dataset.events)
    const rect = this.calendar.getBoundingClientRect()
    const styles = {
      position: 'absolute',
      top: this.calendar.offsetTop,
      height: rect.height,
      width: rect.width
    }
    this.setState({
      mobileOverlayEvents: events,
      mobileStyles: styles
    })
  }

  renderOverlay(event){
    const eventGist = event.gist;
    const pastDay = differenceInCalendarDays(format(event.scheduleDate, "MM/DD/YYYY"), format(Date.now(), "MM/DD/YYYY")) < 0;
    return(
      <div className="overlay-event" key={event.gist.id}>
        <div className="event-title">{eventGist.title}</div>

        <div className="event-date">{format(event.scheduleDate, 'dddd')} | {format(event.scheduleDate, 'MMM D, YYYY')} {eventGist.eventSchedule[0].showTime && `| ${event.schedule.orgEventTime}`}</div>

        <div className="links">
          <a href={eventGist.permalink} className="info">Info</a>
          {eventGist.ticketUrl && !pastDay && <a href={eventGist.ticketUrl} target='_blank' className="event-tickets">Tickets</a>}
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className={`calendar ` + (this.props.mobile ? 'mobile' : '')} ref={div => this.calendar = div}>
        <Header
          month={MONTHS[this.state.month]}
          year={this.state.year}
          next={this.next} 
          prev={this.prev} 
        />
        <div className="calendar-week-days">
          { DAYS_OF_WEEK.map( (day, index) => 
            <div className="week-day" key={index}>
              {day}
            </div>
          )}
        </div>
        <Days 
          {...this.state} 
          events={this.state.events[`${this.state.month}/${this.state.year}`]} 
          toggleDisplayEvents={this.toggleDisplayEvents} 
          mobile={this.props.mobile} 
          displayEventsMobile={this.displayEventsMobile}
        />
        
        { this.state.eventPopup && 
          <div className={`event-popup ${this.state.overflow}` + (this.state.eventPopup ? ' popup-visible' : '')} style={this.state.eventPopupStyles}>
            <GridItem event={this.state.currentEvent} gotoEvent={this.props.gotoEvent} />
          </div> 
        }
        {this.state.mobileOverlayEvents.length > 0 &&
         <div className="overlay-events-container" style={this.state.mobileStyles}>
          <div className="events-close" onClick={() => this.setState({ mobileOverlayEvents: []})}><ion className="ion-close-round"/></div>
          <div className="overlay-events">
            {
              this.state.mobileOverlayEvents.map(event=>{
                return this.renderOverlay(event)
              })
            }
          </div>
         </div> 
        }
      </div>
    )
  }
}







export default Calendar;